import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatUpdatedAgo } from '../../../common/utils/item-util';

export default class CollectionDetail extends Component {
  static propTypes = {
    collection: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  render() {
    const { collection, projectId, version } = this.props;
    const { collectionTitle, collectionName, uuid, updatedAt } = this.props.collection;
    const updatedAgo = formatUpdatedAgo(updatedAt);
    return (
      <div className="d-flex justify-content-around align-content-center">
        <Link
          to={`/2.0/collections/${version}/v/${projectId}/items/${uuid}/name/${collectionName}`}
          className="list-group-item list-group-item-action align-items-center"
          style={{ cursor: 'pointer', width: '90%', float: 'left' }}
        >
          <i className="gjs-caret-icon wb webconnect-database"></i>&nbsp;{collectionTitle}
          <br />
          <small className="text-muted ml-3">{`Updated ${updatedAgo}`}</small>
        </Link>
        <Link
          className="pages-list-left-menu pt-3"
          to={`/2.0/collections/${version}/v/${projectId}/edit/${uuid}`}
        >
          <span
            className="badge badge-theme"
            style={{ padding: 8, cursor: 'pointer', float: 'right' }}
          >
            <i className="gjs-caret-icon wb webconnect-cog" size={'md'}></i>
          </span>
        </Link>
      </div>
    );
  }
}
